import { render, staticRenderFns } from "./SingleTag.vue?vue&type=template&id=20fc2c5e&scoped=true"
import script from "./SingleTag.vue?vue&type=script&lang=js"
export * from "./SingleTag.vue?vue&type=script&lang=js"
import style0 from "./SingleTag.vue?vue&type=style&index=0&id=20fc2c5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fc2c5e",
  null
  
)

export default component.exports